import { ElementRef, HostListener, ViewChild } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilesList } from '../../models/files';
import { FileManagerService } from '../upload-tool/services/file-manager.service';
import {CtxMenuConfig} from "../ctxMenu/ctx-menu-config";
import {DescrittoreSezione} from "../../../common/models/descrittore-sezione";

@Component({
  selector: 'app-upload-progress',
  templateUrl: './upload-progress.component.html',
  styleUrls: ['./upload-progress.component.css']
})
export class UploadProgressComponent implements OnInit, AfterViewInit {
  @Input() descriptor: DescrittoreSezione;
  @Input() file: FilesList;
  @Input() onError = false;
  @Output() onFileItemClick = new EventEmitter();
  @Output() onDeleteItem = new EventEmitter();
  @Output() onEditItem = new EventEmitter();
  @ViewChild('eRef') eRef: ElementRef;
  editMode = false;
  progress;

  constructor(
    private fileManager: FileManagerService
  ) {}

  ngOnInit() {}

  /**
   * After the view is rendered the components listens
   * to upload file service Observables depending on their Behaviour
   */
  ngAfterViewInit(): void {
    if(this.file.progress != 100){
      this.onUploadProgress();
      this.onUploadError();
    }else{
      this.progress = 100;
    }
  }

  /**
   * Tracking click area in order to disable/enable edit name input
   * @param event click event
   */
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if(this.eRef.nativeElement.contains(event.target)) {
      this.editMode = true
    } else {
      this.editMode = false
    }
  }

  /**
   * File Observable emitted persistently while upload is progressing
   */
  private onUploadProgress() {
    this.fileManager.uploadProgress.subscribe(data => {
      if (data && data.fileName === this.file.name) {
        this.progress = data.progress;
      }
    });
  }

  /**
   * File Observable emitted when upload fails
   */
  private onUploadError() {
    this.fileManager.uploadError.subscribe(error => {
      if (error && error.fileName === this.file.name) {
        this.onError = error.error;
      }
    });
  }

  /**
   * Event of single item click
   * @param file
   * @returns emits clicked file data
   */
  onHandleItemClick(file) {
    if(this.onError) return
    this.onFileItemClick.emit(file);
  }

  /**
   * Event of single item deletion
   * @param file
   * @returns emits deleted file data
   */
  onHandleDeleteItemClick(file) {
    this.onDeleteItem.emit(file);
  }

  /**
   * Edits file's name
   * @param event
   */
  onEditItemName(event) {
    let obj = {oldValue: this.file.name, newValue: event.target.value}
    this.onEditItem.emit(obj);
  }

}
